export default "__VITE_ASSET__CGYHGPes__"